export const SET_PRACTICE             = 'setPractice';
export const SET_ADDRESS              = 'setAddress';
export const SET_PHYSICIANS           = 'setPhysicians';
export const SET_STAFF                = 'setStaff';
export const SET_ALLEGRAN             = 'setAllegran';
export const SET_SUPER_ADMIN_PRACTICE = 'setSuperAdminPractice';